<template>
  <div class="page-container indicators-page">
    <portal to="page-name">Dashboard Administrativo</portal>

    <st-tabs @changed="onTabChange">
      <st-tab name="Visão Geral Anual" id="yearly-overview">
        <yearly-overview v-if="loadedTabs.includes('yearly-overview')" />
      </st-tab>
      <st-tab name="Indicadores das Agendas" id="schedules">
        <schedule v-if="loadedTabs.includes('schedules')" />
      </st-tab>
    </st-tabs>
  </div>
</template>

<script>
import YearlyOverview from './indicators/YearlyOverview.vue';
import Schedule from './indicators/Schedule.vue';

export default {
  components: {
    YearlyOverview,
    Schedule,
  },
  data() {
    return {
      loadedTabs: [],
    };
  },
  methods: {
    onTabChange({ tab }) {
      if (!this.loadedTabs.includes(tab.id)) {
        this.loadedTabs.push(tab.id);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.indicators-page {
  .tab-panel {
    padding-top: $layout-spacing;
  }
}
</style>
